import { z } from 'zod';

import {
    BlobImageSchema,
    CostEntryTypeSchema,
    DateOnlySchema,
} from '@/api/common/common.models';
import { PreliminarySchema } from '@/api/preliminaries/preliminaries.models';
import { isoDateString } from '@/lib/zod';

import {
    BaseCostEntryFormModelSchema,
    CostSchema,
    refineCostArrays,
} from '../costs/costs.models';

// PreliminaryCostEntry schema - matches backend PreliminaryCostEntryViewModel
export const PreliminaryCostEntrySchema = z.object({
    id: z.string(),
    preliminaryId: z.string(),
    entryType: CostEntryTypeSchema,
    notes: z.string().nullable(),
    date: DateOnlySchema,
    isSnagging: z.boolean(),
    costs: z.array(CostSchema),
    images: z.array(BlobImageSchema),
    dateCreated: isoDateString,
    dateModified: isoDateString,
});

export type PreliminaryCostEntry = z.infer<typeof PreliminaryCostEntrySchema>;

export const PreliminaryCostEntryFormModelSchema = refineCostArrays(
    BaseCostEntryFormModelSchema.extend({
        notes: z
            .string()
            .max(2000, {
                error: 'Notes cannot be longer than 2000 characters',
            })
            .nullable()
            .optional(),
        date: DateOnlySchema,
        isSnagging: z.boolean(),
    }),
);

export type PreliminaryCostEntryFormModel = z.infer<
    typeof PreliminaryCostEntryFormModelSchema
>;

// PreliminaryCostAggregate schema - matches backend PreliminaryCostAggregateViewModel
export const PreliminaryCostAggregateSchema = z.object({
    parent: PreliminarySchema,
    entries: z.array(PreliminaryCostEntrySchema),
    totalCost: z.number(),
    totalLabourCost: z.number(),
    totalMaterialCost: z.number(),
    totalMiscellaneousCost: z.number(),
    totalHours: z.number(),
    entryCount: z.number(),
    toDateProfitabilityPercentage: z.number(),
});

export type PreliminaryCostAggregate = z.infer<
    typeof PreliminaryCostAggregateSchema
>;
